import Head from "next/head";
import React from "react";

import TabsMenu from "components/global/TabsMenu/TabsMenu";
import ProfileNotifications from "components/profileNotifications/ProfileNotifications/ProfileNotifications";
import CONSTANTS from "config/constants";

const { TITLE } = CONSTANTS;

interface Props {}

const NotificationsPage = (props: Props) => {
  return (
    <>
      <Head>
        <title>Notificaciones | {TITLE}</title>
        <meta name="robots" content="noindex, nofollow" />
      </Head>
      <TabsMenu>
        <ProfileNotifications />
      </TabsMenu>
    </>
  );
};

export default NotificationsPage;
